const ADVANCEMENTS_BEFORE_HINT_MIN = 5;
const ADVANCEMENTS_BEFORE_HINT_MAX = 10;

const makeHints = () => {
    const hints = [];
    let costOfNextHint = 3;
    let comboLessAdvancementsUntilNextHint = ADVANCEMENTS_BEFORE_HINT_MAX;

    const service = {
        shouldCreateHint: () => {
            return comboLessAdvancementsUntilNextHint <= 0;
        },

        builtAdvancementWithCombo: () => {
            comboLessAdvancementsUntilNextHint = Math.round(Math.random()*(ADVANCEMENTS_BEFORE_HINT_MAX-ADVANCEMENTS_BEFORE_HINT_MIN)+ADVANCEMENTS_BEFORE_HINT_MIN);
        },

        builtAdvancementWithoutCombo: () => {
            comboLessAdvancementsUntilNextHint -= 1;
        },

        getNextHintCost: () => costOfNextHint,

        getAllHintsForAdvancement: advancementId => hints.filter(h => h.advancementId === advancementId),

        peekHint: (allPotentialNonResourceBasedAdvancements, isKnown, maxLevel) => {
            const viable = allPotentialNonResourceBasedAdvancements
                .filter(a => a.requirements && a.level <= maxLevel && !isKnown(a.id) && (a.ancestor === undefined || isKnown(a.ancestor)))
                .flatMap(a => a.requirements.map(r => ({ advancementId: a.id, requirementIds: r })))
                .filter(v => v.requirementIds.every(isKnown))
                .filter(v => 
                    !service.getAllHintsForAdvancement(v.advancementId)
                        .find(h => h.requirementIds.length === v.requirementIds.length && h.requirementIds.every(r => v.requirementIds.find(rr => r === rr))));
            if (viable.length === 0) {
                return undefined;
            } else {
                return viable[Math.floor(Math.random()*0.999999*viable.length)];
            }
        },

        createHint: (allPotentialNonResourceBasedAdvancements, isKnown, maxLevel) => {
            const hint = service.peekHint(allPotentialNonResourceBasedAdvancements, isKnown, maxLevel);
            if (hint === undefined) {
                return undefined;
            } else {
                hints.push(hint);
                comboLessAdvancementsUntilNextHint = Math.round(Math.random()*(ADVANCEMENTS_BEFORE_HINT_MAX-ADVANCEMENTS_BEFORE_HINT_MIN)+ADVANCEMENTS_BEFORE_HINT_MIN);
                costOfNextHint = 3 + Math.floor(hints.length/5);
                return hint;
            }
        },
        
        getAllHintsSoFar: () => [...hints]
    };

    return service;
};

export default makeHints;